/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/**
 * Creates new cancellable promise
 * @param {Promise} newPromise - new promise to convert into cancellable promise.
 * @param {Cancellable Promise Object} oldPromise - old cancellable promise for which complete / cancel to be called
 * on resolve / reject of new promise.
 */
export const cancellablePromise = (newPromise, oldPromise = undefined) => {
  let cancel;
  let complete;
  const promise = new Promise((resolve, reject) => {
    newPromise
      .then(res => {
        if (oldPromise) {
          oldPromise.complete();
        }
        resolve(res);
      })
      .catch(err => {
        if (oldPromise) {
          oldPromise.cancel();
        }
        reject(err);
      });
    cancel = reject;
    complete = resolve;
  });
  return {
    promise,
    cancel,
    complete
  };
};
